import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/pinterest.constant";

export {
    addPinterestPinSyncs,
    addSinglePinterestPinSync,
    updateSinglePinterestPinSync,
    getSinglePinterestPinSync,
    searchPinterestPinSyncs,
    searchPinterestPinSyncsWithSearchCriteria,
    preparePinterestPinSyncsList
}

const collectionName = 'pinterest-pin-syncs';
const collectionReference = collection(fireStoreDB, collectionName);

const addPinterestPinSyncs = (pinterestPinSyncs) => {
    return Promise.map(pinterestPinSyncs, async pinterestPinSync => {
        await addSinglePinterestPinSync(pinterestPinSync);
    });
}

const addSinglePinterestPinSync = (pinterestPinSync) => {
    pinterestPinSync.createdAt = new Date();
    pinterestPinSync.updatedAt = pinterestPinSync.createdAt;
    return addDoc(collectionReference, pinterestPinSync);
}

const updateSinglePinterestPinSync = (pinterestPinSync) => {
    console.log('updateSinglePinterestPinSync', pinterestPinSync);

    const documentReference = doc(fireStoreDB, collectionName, pinterestPinSync.id);
    pinterestPinSync.updatedAt = new Date();
    return setDoc(documentReference, pinterestPinSync);
}

const getSinglePinterestPinSync = async (pinterestPinSyncId) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestPinSyncId);
    const pinterestPinSyncDoc = await getDoc(documentReference);
    return prepareSinglePinterestPinSync(pinterestPinSyncDoc);
}

const searchPinterestPinSyncs = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const pinterestPinSyncResult = await getDocs(searchQuery);
    return preparePinterestPinSyncsList(pinterestPinSyncResult);
}

const searchPinterestPinSyncsWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPinterestPinSyncsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const pinterestPinSyncResult = await getDocs(searchQuery);
    return preparePinterestPinSyncsList(pinterestPinSyncResult);
}

const preparePinterestPinSyncsList = (pinterestPinSyncResult) => {
    const pinterestPinSyncsList = [];

    _.forEach(pinterestPinSyncResult.docs, pinterestPinSyncDoc => {
        pinterestPinSyncsList.push(prepareSinglePinterestPinSync(pinterestPinSyncDoc));
    });

    return pinterestPinSyncsList;
}


const prepareSinglePinterestPinSync = (pinterestPinSyncDoc) => {
    const pinterestPinSync = pinterestPinSyncDoc.data();
    pinterestPinSync.id = pinterestPinSyncDoc.id;
    return pinterestPinSync;
}
